import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { ViewDirectionPreset } from '@3d-scene/common/scene/controls/camera-controls.interface';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { Box3 } from 'three';
import { ArticleContainerUtils } from '@3d-scene/model3d/util/article-container-utils';
import { LayerManager } from '@3d-scene/manager/layer-manager';
import { SelectionModel } from '@project/components/article/model/selection.model';
import { SelectionModelService } from '@project/components/article/service/selection-model.service';
import { CameraControl } from '@3d-scene/common/scene/controls/camera-control';
import { SceneManager } from '@3d-scene/manager/scene.manager';
import { GlobalArticleContainerUtils } from '@3d-scene/model3d/util/global-article-container-utils';

@Component({
  standalone: false,
  selector: 'app-toolbar-perspective-menu',
  templateUrl: './toolbar-perspective-menu.component.html',
  styleUrls: ['../toolbar.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarPerspectiveMenuComponent {

  @Output() public defaultPositionEvent = new EventEmitter<void>();

  constructor(
    private layerManager: LayerManager,
    private selectionModel: SelectionModel,
    private selectionModelService: SelectionModelService,
    private sceneManager: SceneManager,
    private globalArticleContainerUtils: GlobalArticleContainerUtils) {
  }

  public get controls(): CameraControl {
    return this.sceneManager.sceneControls;
  }

  public view(view: ViewDirectionPreset, offsetLeft = 0) {
    if (view !== 'top') {
      this.layerManager.hideStaticLayers();
    }
    this.controls.view(view, {left: offsetLeft});
  }

  public viewSelected() {
    if (this.selectionModel.isArticleSelection()) {
      const containers: ArticleContainer[] = this.selectionModelService.getArticleContainers();
      const bbox: Box3 = ArticleContainerUtils.calculateBBoxForArticles(containers);
      this.controls.viewByBBox(bbox);
    }
  }

  public viewAll() {
    const bbox: Box3 = this.globalArticleContainerUtils.calculateBBoxForAllArticlesInGlobal();
    this.controls.viewByBBox(bbox);
  }

  public setCameraDefaultPosition() {
    this.defaultPositionEvent.emit();
  }
}
